<div class="help-item" role="treeitem" [attr.aria-expanded]="hasChildren ? expanded : null">
  <div class="help-row d-flex align-items-center" [style.padding-left.rem]="0.5 + depth * 0.75">
    @if (isTopic) {
      <a
        [routerLink]="['/help', node.id]"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="help-link flex-grow-1 d-flex align-items-center gap-2 text-decoration-none"
      >
        @if (node.icon) {
          <i class="bi" [class]="'bi-' + node.icon"></i>
        }
        <span class="help-label">{{ node.title }}</span>
      </a>
    } @else {
      <button
        type="button"
        class="help-link flex-grow-1 btn btn-link d-flex align-items-center gap-2 text-decoration-none text-start"
        (click)="toggleExpanded()"
      >
        @if (node.icon) {
          <i class="bi" [class]="'bi-' + node.icon"></i>
        }
        <span class="help-label text-uppercase fw-semibold">{{ node.title }}</span>
      </button>
    }

    @if (hasChildren) {
      <button type="button" class="btn btn-sm help-toggle" (click)="toggleExpanded()" aria-label="Toggle section">
        <i class="bi bi-chevron-down help-chevron" [class.expanded]="expanded"></i>
      </button>
    }
  </div>

  @if (hasChildren) {
    <div class="help-children" [class.expanded]="expanded">
      <div class="help-children-inner" role="group">
        @for (child of node.children; track child.id) {
          <adf-help-tree-item [node]="child" [depth]="depth + 1" [openIds]="openIds" />
        }
      </div>
    </div>
  }
</div>
